<template lang='pug'>
  r-table(
    ref='table'
    remind-key='wh-pack-list'
    no-data-text='Sin packs.'
    v-bind='tableProps'
    @detail='submitUpdate'
    @remove='submitDelete'
    )
</template>

<script>
  //
  import { RTable } from '@/components/reusable_components/next'
  import translatorService from '@/services/translator'
  //
  import WhPackFilters from '@/views/Warehouse/WhPack/WhPackFilters'
  import WhPackHeaders from '@/views/Warehouse/WhPack/WhPackHeaders'
  import WhPackService from '@/services/api/warehouse/WhPack'
  import WhProductService from '@/services/api/warehouse/WhProduct'
  import WhProductModel from '@/models/Warehouse/WhProduct'
  //
  export default {
    components: {
      RTable,
    },
    computed: {
      tableProps() {
        return {
          filters: WhPackFilters,
          headers: WhPackHeaders.list,
          service: WhProductService.toPackList(),
          paramFilter: {
            type: 'pack'
          },
        }
      }
    },
    data() {
      return {
        selected: null,
      }
    },
    methods: {
      showDeleteSuccess() {
        this.showSuccessSnackbar('Pack eliminado exitosamente.')
      },
      submitCreate() {
        this.$router.push({ name: 'wh-pack-create' })
      },
      submitDelete(event) {
        this.selected = event.item
        this.showWarningSnackbar({
          title: 'Eliminar',
          message: '¿Esta seguro en eliminar el paquete seleccionado?',
          confirm: 'eliminar',
        })
      },
      submitUpdate(event) {
        this.$router.push({ name: 'wh-pack-update', params: { id: event.item.id } })
      },
      toDelete() {
        return this
          .selected
          .delete()
          .then(this.showDeleteSuccess)
          .then(this.toRefresh)
          .catch(this.showDeleteError)
      },
      toRefresh() {
        return this
        .$refs
        .table
        .refresh()
      },
    },
    watch: {
      responseConfirmSnackbar(value) {
        switch(value) {
          case 'eliminar': return this.toDelete();
        }
      },
    },
    created() {
    },
    mounted() {
      this.setTitle('Packs')
      this.setItems([
        {
          icon: 'add_circle',
          text: 'crear pack',
          action: this.submitCreate,
        }
      ])
    }
  }
</script>